import * as sessionStorageService from 'sessionStorageService';

const userInfoKey = 'userInfo';
const confUsrKey = 'configUsuario';
const usrSecWebOptsKey = 'userSecurityWebOptions';

export async function getUserInfo(key, cache, params = {}) {
  // Dentro del login y tras el registerSession inicial deberíamos descartar la caché del userInfo
  const userInfo = cache ? sessionStorageService.get(userInfoKey) : null;

  if (userInfo === null) {
    return getSessionInfo(params).then((data) => getInternal(data, key));
  }

  return getInternal(userInfo, key);
}

/**
 * Indicamos params sólo para gestionar errores (es como el antiguo credentials)
 *
 * @param {*} params
 * @returns
 */
async function getSessionInfo(params) {
  const response = await fetch('/connect/getSessionInfo', {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      tokena: sessionStorage.getItem('tokena'),
    },
    body: JSON.stringify(params),
  });

  if (!response.ok) {
    throw await response.json();
  }

  const data = await response.json();
  sessionStorageService.set(userInfoKey, data);
  return data;
}

function getValueFromUserInfo(userInfo, key) {
  if (key.match(`^${confUsrKey}.`)) {
    const key2 = key.substring(confUsrKey.length + 1, key.length);
    return userInfo[confUsrKey][key2];
  } else if (key.match(`^${usrSecWebOptsKey}.`)) {
    const key2 = key.substring(usrSecWebOptsKey.length + 1, key.length);
    return userInfo[usrSecWebOptsKey][key2];
  } else {
    return userInfo[key];
  }
}

function getKey(key) {
  if (key.match(`^${confUsrKey}.`)) {
    return key.replace(`${confUsrKey}.`, '');
  } else if (key.match(`^${usrSecWebOptsKey}.`)) {
    return key.replace(`${usrSecWebOptsKey}.`, '');
  } else {
    return key;
  }
}

function getInternal(userInfo, storageKey) {
  let reply = null;

  if (Array.isArray(storageKey)) {
    reply = {};
    storageKey.forEach((key) => {
      reply[getKey(key)] = getValueFromUserInfo(userInfo, key);
    });
  } else if (typeof storageKey === 'string') {
    reply = getValueFromUserInfo(userInfo, storageKey);
  }
  return reply;
}
